const drinks = [
  {
    regNum: 200,
    item: 'glass fee',
    desc: '',
  },
  {
    regNum: 201,
    item: 'hot sake - small',
    desc: '',
  },
  {
    regNum: 202,
    item: 'hot sake - large',
    desc: '',
  },
  {
    regNum: 203,
    item: 'kurosawa (nagano) - glass',
    desc: 'house sake - dry',
  },
  {
    regNum: 204,
    item: 'kurosawa (nagano) - bottle',
    desc: 'house sake - dry',
  },
  {
    regNum: 205,
    item: 'sake a - glass',
    desc: 'takizawa (nagano) - mildly dry, hakkaisan (niigata) - dry, otokoyama (hokkaido) - very dry, namahage (akita) - very dry, kubota daiginjo (niigata) - mildly dry',
  },
  {
    regNum: 206,
    item: 'sake a - bottle',
    desc: 'takizawa (nagano) - mildly dry, hakkaisan (niigata) - dry, otokoyama (hokkaido) - very dry, namahage (akita) - very dry, kubota daiginjo (niigata) - mildly dry',
  },
  {
    regNum: 207,
    item: 'sake b - glass',
    desc: 'narutodai (draft sake) (tokushima) - dry, kurosawa daiginjo (nagano) - mildly dry',
  },
  {
    regNum: 208,
    item: 'sake b - bottle',
    desc: 'narutodai (draft sake) (tokushima) - dry, kurosawa daiginjo (nagano) - mildly dry',
  },
  {
    regNum: 209,
    item: 'sake c - glass',
    desc: 'kenbishi (hyogo)- mildly dry',
  },
  {
    regNum: 210,
    item: 'sake c - bottle',
    desc: 'kenbishi (hyogo) - mildly dry',
  },
  {
    regNum: 211,
    item: 'sake d - glass',
    desc: 'onigoroshi (shizuoka) - dry',
  },
  {
    regNum: 212,
    item: 'sake d - bottle',
    desc: 'onigoroshi (shizuoka) - dry',
  },
  {
    regNum: 213,
    item: 'katsuyama (miyagi) - glass',
    desc: 'mildly dry',
  },
  {
    regNum: 214,
    item: 'katsuyama (miyagi) - bottle',
    desc: 'mildly dry',
  },
  {
    regNum: 230,
    item: 'hakkaisan yukimuro (niigata) - glass',
    desc: 'mildly dry',
  },
  {
    regNum: 231,
    item: 'hakkaisan yukimuro (niigata) - bottle',
    desc: 'mildly dry',
  },
  {
    regNum: 215,
    item: 'small beer',
    desc: 'asahi',
  },
  {
    regNum: 217,
    item: 'large beer',
    desc: 'sapporo / asahi',
  },
  {
    regNum: 219,
    item: 'chardonnay - glass',
    desc: 'la crema',
  },
  {
    regNum: 220,
    item: 'chardonnay - bottle',
    desc: 'la crema',
  },
  {
    regNum: 221,
    item: 'pinot noir - glass',
    desc: 'la crema',
  },
  {
    regNum: 222,
    item: 'pinot noir - bottle',
    desc: 'la crema',
  },
  {
    regNum: 223,
    item: 'cabernet sauvignon - glass',
    desc: 'souverain',
  },
  {
    regNum: 224,
    item: 'cabernet sauvignon - bottle',
    desc: 'souverain',
  },
  {
    regNum: 225,
    item: 'san pellegrino',
    desc: 'sparkling mineral water',
  },
  {
    regNum: 226,
    item: 'perrier',
    desc: 'carbonated mineral water',
  },
  {
    regNum: 227,
    item: 'green tea iced',
    desc: 'ito en oi oocha',
  },
  {
    regNum: 228,
    item: 'fiji bottled water',
    desc: '',
  },
  {
    regNum: 229,
    item: 'apple juice',
    desc: '',
  },
  {
    regNum: 250,
    item: 'cork fee wine',
    desc: '',
  },
  {
    regNum: 251,
    item: 'cork fee sake',
    desc: '',
  },
  {
    regNum: 260,
    item: 'nigori',
    desc: '',
  },
  {
    regNum: 261,
    item: 'umeshu - glass',
    desc: 'plum wine',
  },
  {
    regNum: 262,
    item: 'umeshu - bottle',
    desc: 'plume wine',
  },
  {
    regNum: 281,
    item: 'soda can',
    desc: 'coke, diet coke, 7-up',
  },
  {
    regNum: 252,
    item: 'cork fee - wine - 2 people',
    desc: '',
  },
  {
    regNum: 253,
    item: 'cork fee - sake - 2 people',
    desc: '',
  },
];

export default drinks;